<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Rechercher par antécédent</div>
      <div class="modal-body" *ngIf="inputSearchForm">
        <div class="search-bar">
          <input [formGroup]="inputSearchForm" [formControl]="inputSearchForm.get('searchInput')"
          placeholder="Rechercher un antécédent" type="text">
        </div>

        <div class="table-wrapper">
          <frg-table
            *ngIf="patientsTable && patientsTable.objects && patientsTable.objects.length > 0 && noResultMsg === ''"
            [keysBody]="patientsTable"
            [keysColumn]="patientsTableColumn"
            isRowsClickable="true"
            (onClickRow)="addRemovePatient($event)"
            (onClickHeader)="headerClick($event)"
            (onSort)="sortPatients($event)"
          ></frg-table>
          <div class="no-result-message" *ngIf="noResultMsg !== ''">{{ noResultMsg }}</div>
        </div>
      </div>
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="closeModal(true)" [disabled]="selectedPatients.length === 0">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>